function showCTAPlanInPDP(planInCart,isLoggedIn,plan){
    //console.log("showCTAPlanInPDP : ", planInCart,isLoggedIn,plan);
    var hasPlan = true;
    if(plan === '0'){
        hasPlan = false;
    }
    if(planInCart || (isLoggedIn && hasPlan)){
        $('.maf-select-plan-pdp-cta').hide();
        $('.maf-add-to-cart-pdp-cta').show();
    } else{
        $('.maf-add-to-cart-pdp-cta').hide();
        $('.maf-select-plan-pdp-cta').show();        
    }
}

function showCopyInCart(planInCart){
    if($('.maf-cart-noplan-copy-choice')){
        if(planInCart){
            $('.maf-cart-noplan-copy-choice').hide();
            $('.maf-cart-noplan-copy-alreadyplan').show();            
        } else{
            $('.maf-cart-noplan-copy-alreadyplan').hide();
            $('.maf-cart-noplan-copy-choice').show();
            
        }
    }
}

function checkIfPlanInCart(){
    var url = "/on/demandware.store/Sites-medicalert-Site/en_US/Cart-CheckProductLineItem";
    $.ajax({
        url:      url,
        type:     'GET',
        dataType: 'json',
        success:  function(data) {
            showCTAPlanInPDP(data.value,data.logged,data.memberPlan);
            showCopyInCart(data.value);
        }
    });
}
checkIfPlanInCart();

